import _ from "lodash";
import { serializeRestConnector, connectorPlaceholderImage, generateUserPicture } from "../../common/utils";
import {
  WIZARD_GO_TO_CONNECTORS,
  WIZARD_GO_TO_NEW_CONNECTOR_FORM,
  WIZARD_CREATE_CONNECTOR,
  WIZARD_UPDATE_PROFILE,
  GET_FEATURED_CONNECTORS,
  TEST_CONNECTION,
  CLEAR_TESTED_CONNECTION,
  CLEAR_FEATURED_CONNECTORS,
  CLEAR_CREATED_CONNECTION,
  WIZARD_GO_TO_FINAL_SCREEN,
  CLEAR_ALL_WIZARD_STATE,
  AUTH_USER,
  WIZARD_CHOOSE_STEP
} from "./types";
import { fetchSkill } from "./skillActions";
import { Analytics, Auth, API} from "aws-amplify";
import { ANALYTICS_EVENT } from "../../common/ApmlifyRecordEvents";
import {getEnvironmentName} from "../../utils"
import { Step } from "@material-ui/core";
const environment = getEnvironmentName()
const config = require("../../app_configuration").CONFIGURATION[environment];

const apiRequestFixedParams = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

const mapFormUserAttributesToCognitoAttributes = formValues => {

  let values = formValues;
  if(formValues.phoneNumber != "" && formValues.phoneNumber != undefined) {
    values.phoneNumber = formValues.phoneNumber.includes("+")?formValues.phoneNumber:`+1${formValues.phoneNumber}`;
  }

  const attributeKeys = [
    { form: "firstName", cognito: "given_name" },
    { form: "lastName", cognito: "family_name" },
    { form: "companyName", cognito: "custom:company_name" },
    { form: "jobTitleOrRole", cognito: "custom:title" },
    { form: "phoneNumber", cognito: "phone_number" }
  ];

  return attributeKeys.reduce((attributes, attrKeyMap) => {
    if (values[attrKeyMap.form]) {
      attributes[attrKeyMap.cognito] = values[attrKeyMap.form];
    }
    return attributes;
  }, {});
};

export const wizardChooseConnectors = () => {
  localStorage.setItem("wizardStep", "choose-connectors");
  return {
    type: WIZARD_GO_TO_CONNECTORS,
    payload: { step: "choose-connectors" }
  };
}; 

export const wizardChooseStep = (nextStep) => {
  localStorage.setItem("wizardStep", nextStep);
  return {
    type: WIZARD_CHOOSE_STEP,
    payload: { step: nextStep }
  };
}; 


export const wizardNewConnectorForm = (connectorType, connector) => {
  return {
    type: WIZARD_GO_TO_NEW_CONNECTOR_FORM,
    payload: { step: "new-connector-form", connectorType: connectorType, connectorTemplate: connector }
  };
};

export const testConnection = formValues => async dispatch => {
  dispatch({
    type: TEST_CONNECTION,
    payload: { step: "new-connector-form", connectionBeingTested: formValues, status: 200 }
  });
};

export const clearTestedConnectionState = () => {
  return {
    type: CLEAR_TESTED_CONNECTION
  };
};

export const wizardCreateConnector = (formValues, connectorType, connector, url = "") => async (dispatch, getState) => {
  
  const state = getState();
  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "CreateConnection",
      Skill: state.skill.appId,
      FormParams: serializeRestConnector(
        connector,
        formValues.connectorClientId,
        formValues.connectorClientSecret,
        url
      ),
      ...apiRequestFixedParams
    }
  };

  const action = {
    type: WIZARD_CREATE_CONNECTOR,
    payload: { connectorType: connectorType }
  };

  try {
    const response = await API.post(config.AWS_API_NAME, "connectors/new", data);

    if (response.status === "Connected!") {
      action.payload.status = 200;
      action.payload.oauthRedirectUrl = response.oauth2_user_redirect_link;
    } else {
      action.payload.status = 500;
      action.payload.oauthRedirectUrl = null;
    }
  } catch (err) {
    action.payload.status = 500;
    action.payload.oauthRedirectUrl = null;

    console.log(err);
  }

  dispatch(action);
};


  export const wizardConnectCollaborationTool = (connectionId, redirectUrl) => async (dispatch, getState) => {

   /*  const state = getState();
    let data = { 
      body: {
        AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
        ApiCall: "OAuth2Callback",
        Connection: connectionId,
        OAuth2UserRedirectLink: redirectUrl,
        ...apiRequestFixedParams 
      }
    };

    const response = await API.post(config.AWS_API_NAME, "connectors/enable", data);
    console.log(response);
    if (response.status !== "success") {
      const analytics_data = {
        connectionId: connectionId,
        errorMessage: response.message
      };
      Analytics.record(ANALYTICS_EVENT(analytics_data).CONNECTION.error);
    } else {
      const analytics_data = {
        connectionId: connectionId
      };
      Analytics.record(ANALYTICS_EVENT(analytics_data).CONNECTION.success);
    }
    dispatch({
      type: WIZARD_CONNECT_COLLABORATION_TOOL,
      payload: response.status === "error" ? false : true
    }); */
  };

export const wizardUpdateProfile = (user, formValues) => async (dispatch, getState) => {
  const action = {
    type: WIZARD_UPDATE_PROFILE,
    payload: {
      status: 200,
      errorMessage: null
    }
  };

  const userAttributes = mapFormUserAttributesToCognitoAttributes(formValues);
  console.log(userAttributes);

  let avatar = await generateUserPicture(null, userAttributes.given_name + " " + userAttributes.family_name);

  userAttributes.picture = avatar;

  try {
    const response = await Auth.updateUserAttributes(user, userAttributes);

    if (response === "SUCCESS") {
      localStorage.setItem("wizardStep", 1);
      action.payload.step = 1;
    } else {
      action.payload.status = 500;
      action.payload.errorMessage = response.message ? response.message : null;
    }

    // Get latest user data from Cognito (ignore any cached data)
    const currentAuthUser = await Auth.currentAuthenticatedUser({
      bypassCache: true
    });
    dispatch({ type: AUTH_USER, payload: currentAuthUser });
  } catch (err) {
    action.payload.status = 500;
    action.payload.errorMessage = err.message;
  }

  dispatch(action);
};

export const wizardGetFeaturedConnectors = () => async (dispatch, getState) => {
  const action = {
    type: GET_FEATURED_CONNECTORS,
    payload: { step: "choose-connectors", status: 200 }
  };

  const state = getState();
  let data = {
    queryStringParameters: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "ListFeaturedConnectors"
    }
  };

  try {
    const response = await API.get(config.AWS_API_NAME, "connectors/featured", data);

    // We ignore these connectors since they require some additional user input (subdomain);
    // check out ConnectionDialog/index.js for the custom logic related to the custom connectors URLs
    // const customConnectors = ["servicenow-prod", "zendesk-prod", "Dynamics_365"];
    const customConnectors = [];

    console.log(555, response);

    action.payload.status = response.code;
    const nonCustomConnectors = _.filter(
      response.data,
      connector => customConnectors.indexOf(connector.connectionName) === -1
    ); // Don't feature custom connectors

    action.payload.featuredConnectors = _.take(nonCustomConnectors, 30).map(connector => {
      return {
        img: connector.image ? connector.image : connectorPlaceholderImage,
        type: connector.connectorName,
        shortDesc: connector.shortDesc ? connector.shortDesc : `${connector.connectorName} connector`,
        longDesc: connector.longDesc
          ? connector.longDesc
          : `Click here to create a new ${connector.connectorName} connector.`,
        data: connector
      };
    });
  } catch (err) {
    action.payload.status = 500;
    action.payload.featuredConnectors = [];
  }

  dispatch(action);
};

export const clearFeaturedConnectors = () => (dispatch, getState) => {
  dispatch({ type: CLEAR_FEATURED_CONNECTORS });
};

export const clearCreateConnectionState = () => {
  return { type: CLEAR_CREATED_CONNECTION };
};

export const goToFinalWizardScreen = () => async (dispatch, getState) => {
  let currentAuthUser = await Auth.currentAuthenticatedUser({
    bypassCache: true
  });
  const state = getState();

  if (!_.get(currentAuthUser, "attributes.picture", undefined)) {
    let avatar = await generateUserPicture(currentAuthUser, currentAuthUser.username);
    await Auth.updateUserAttributes(currentAuthUser, { picture: avatar });
    currentAuthUser = await Auth.currentAuthenticatedUser({
      bypassCache: true
    });
  }

  dispatch({ type: AUTH_USER, payload: currentAuthUser });

  localStorage.setItem("wizardStep", "connector-created-info");

  dispatch({ type: WIZARD_GO_TO_FINAL_SCREEN });
  dispatch(fetchSkill());
};

export const clearAllWizardState = () => {
  return { type: CLEAR_ALL_WIZARD_STATE };
};
